import config from '../config';

export default class RequestAbstract {
    _config = config;
    data;

    updateLocalStorageUser(result) {
        if (result.error === 'OK' && result.user) {
            localStorage.user = JSON.stringify(result.user);
            localStorage.token = result.session;
            localStorage.role = result.user.role.name;
            localStorage.systemRole = result.user.role.systemRole;
        }
        if (result.error === 'OK' && result.session) {
            localStorage.token = result.session;
        }
    }

    async refreshStatus(id) {
        return await this.loadWithAuth(this.link + `/refresh/${id}`, { method: 'GET' });
    }

    async export(filter, sort, paging) {
        return await this.loadWithAuth(
            this.link + '/export',
            {
                method: 'POST',
                body: JSON.stringify({ filter, sort, paging })
            },
            { fileDownload: true }
        );
    }

    async exportTask(body, qs = '') {
        return await this.loadWithAuth(
            this.link + '/export/task' + qs,
            {
                method: 'POST',
                body: JSON.stringify(body)
            },
        );
    }

    async patch(link, props) {
        return await this.loadWithAuth(link, {
            method: 'PATCH',
            body: JSON.stringify(props)
        });
    }

    async postForm(link, data, headers = {}) {
        const body = Object.entries(data)
            .map(
                ([key, value]) =>
                    encodeURIComponent(key) + '=' + encodeURIComponent(value)
            )
            .join('&');

        const { language } = this._config;

        return await this.load(link, {
            method: 'POST',
            headers: {
                ...headers,
                'Content-Type': 'application/x-www-form-urlencoded',
                "Language": localStorage.language || language
            },
            body
        });
    }

    async authPostForm(link, data, headers = {}) {
        const body = Object.entries(data)
            .map(
                ([key, value]) =>
                    encodeURIComponent(key) + '=' + encodeURIComponent(value)
            )
            .join('&');

        const { language } = this._config;

        return await this.loadWithAuth(link, {
            method: 'POST',
            headers: {
                ...headers,
                'Content-Type': 'application/x-www-form-urlencoded',
                "Language": localStorage.language || language
            },
            body
        });
    }

    async getAll() {
        return await this.getAllFiltered(
            [],
            [
                {
                    field: 'id',
                    direction: 'desc'
                }
            ]
        );
    }

    async search(limit, filter = [], sort = [], prefilter, props) {
        return await this.getFiltered(
            this.link,
            filter,
            sort,
            {
                page: 0,
                pageSize: limit || 1000
            },
            { prefilter, ...props }
        );
    }

    async getLight(filter = [], sort = [], props) {
        return await this.getFiltered(
            this.link + '/light',
            filter,
            sort,
            {
                page: 0,
                pageSize: 10000
            },
            props
        );
    }

    async getAllFiltered(filter = [], sort = [], props) {
        return await this.getFiltered(
            this.link,
            filter,
            sort,
            {
                page: 0,
                pageSize: 1000
            },
            props
        );
    }

    async getFiltered(link, filter, sort, paging, props = {}) {
        const prefilter = props.prefilter || [];
        return await this.post(link, {
            filter,
            sort,
            paging,
            prefilter,
            ...props
        });
    }

    async add(info) {
        return await this.loadWithAuth(this.link + '/add/', {
            method: 'POST',
            body: JSON.stringify(info)
        });
    }

    async update(id, info) {
        return await this.loadWithAuth(this.link + '/update/' + id, {
            method: 'POST',
            body: JSON.stringify(info)
        });
    }
    async getToken(id, body) {
        return await this.loadWithAuth(this.link + '/token', {
            method: 'POST',
            body: JSON.stringify(body)
        });
    }

    async delete(ids) {
        return await this.loadWithAuth(this.link + '/delete/' + ids.join(','), {
            method: 'GET'
        });
    }
    async archive(ids) {
        return await this.loadWithAuth(this.link + '/archive/' + ids.join(','), {
            method: 'GET'
        });
    }

    async lock(info) {
        return await this.loadWithAuth(this.link + '/lock/', {
            method: 'POST',
            body: JSON.stringify(info)
        });
    }

    async toggle(id, field, value) {
        return await this.patch(`${this.link}/toggle/${id}/${field}/${value}`);
    }

    async get(link) {
        return await this.loadWithAuth(link, { method: 'GET' });
    }

    async generatePdf(id, token) {
        const url = `${this.link}/${id}/${token}`;
        return await this.loadWithAuth(
            url,
            {
                method: 'GET'
            },
            { fileDownload: true }
        );
    }

    async post(link, props) {
        return await this.loadWithAuth(link, {
            method: 'POST',
            body: JSON.stringify(props)
        });
    }

    async loadWithAuth(link, props = {}, params = {}) {
        if (!props.headers) props.headers = {};
        const { language } = this._config;
        props.headers['X-Auth-Token'] = localStorage.token;
        props.headers['Language'] = localStorage.language || language;

        if (!props.headers['Content-Type']) {
            props.headers['Content-Type'] = 'application/json';
        }

        if (params.fileUpload) {
            delete props.headers['Content-Type'];
        }

        if (params.fileDownload) {
            return await this.loadBinary(link, props);
        }

        return await this.load(link, props);
    }

    handleUnauthorized(errorMsg) {
        this.data.navigate('/login');

        if (localStorage.token || localStorage.user) {
            this.data.updateAlertError(errorMsg, 'snackbar');
        }

        localStorage.removeItem('token');
        localStorage.removeItem('user');
    }

    async load(link, props) {
        let resp = { code: 'initial', status: 0 };
        const url = this.getFullLink(link);

        try {
            const response = await fetch(url, props);
            resp.status = response.status;

            const processedResp = await response.json();
            resp = { ...resp, ...processedResp };

            if (!response.ok) {
                throw new Error(
                    `HTTP error! status: ${response.status}, message: ${resp.message}`
                );
            }
        } catch (error) {
            resp.message = error.message;
        }
        this.handleStatus(resp);
        return resp;
    }

    async loadBinary(link, props) {
        let resp = { code: 'initial', status: 0 };
        const url = this.getFullLink(link);

        try {
            const response = await fetch(url, props);
            resp.status = response.status;

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(
                    `HTTP error! status: ${response.status}, message: ${errorText}`
                );
            }

            resp.data = await response.blob();
            resp.message = 'Request succeeded';
        } catch (error) {
            resp.message = error.message;
        }

        this.handleStatus(resp);
        return resp;
    }

    handleStatus(resp) {
        if (resp.status === 401 || resp.status === 403) {
            if (window.location.pathname !== '/login') {
                this.handleUnauthorized(resp.message);
            }
        }
    }

    getFullLink(link) {
        //return this._config.serverHost + "/" + link;
        return '/' + link;
    }

    getSortField(sortKey, direction) {
        const sort = [];
        if (sortKey) {
            sort.push({
                field: sortKey,
                direction
            });
        }
        return sort;
    }
}
